module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/manage-auction-configuration/manage-auction-configuration.component.css
// module id = ./src/app/manage-auction-configuration/manage-auction-configuration.component.css
// module chunks = main